import React from 'react';
import { colors, ApButtonIcon } from '@alixpartners/ui-components';

import {
	Wrapper,
	ToggleWrapper,
	Label,
	HeaderRow,
	ContentRow,
} from './ChartOptionsCollapsible.styles';

export const ChartOptionsCollapsible = ({ header, children }) => {
	const [isExpanded, setExpanded] = React.useState(true);

	const handleExpandToggle = () => {
		setExpanded(!isExpanded);
	};

	return (
		<Wrapper>
			<HeaderRow>
				{header && header()}
				<ToggleWrapper onClick={handleExpandToggle}>
					<ApButtonIcon
						iconName="baseline_tune"
						iconProps={{ iconColor: colors.grey8 }}
					/>
					<Label>{`${isExpanded ? 'Hide' : 'Show'} options`}</Label>
				</ToggleWrapper>
			</HeaderRow>
			<ContentRow expanded={isExpanded}>{children && children}</ContentRow>
		</Wrapper>
	);
};
